'use client';
import React, { useState } from 'react';
import { Star, ThumbsUp, MoreHorizontal } from 'lucide-react';

type Evaluation = {
  id: string;
  user: {
    name: string;
    avatar: string;
  };
  rating: number;
  date: string;
  content: string;
  images?: string[];
  variant?: string;
  helpfulCount: number;
};
const evaluateList: Evaluation[] = [
  {
    id: '1',
    user: {
      name: '张**工',
      avatar: '/d/u1.jpg',
    },
    rating: 5,
    date: '2024-03-12',
    content: '这款阶梯式膜片式联轴器做工非常精细，装配精度高，运行过程中基本无振动。用在高速设备上表现稳定，膜片弹性很好，长期运行也没有出现疲劳问题，整体非常满意。',
    images: [
      '/d/1.webp',
      '/d/4.webp',
    ],
    variant: '阶梯式膜片式联轴器-螺钉夹紧型-单膜片',
    helpfulCount: 86,
  },
  {
    id: '2',
    user: {
      name: '李**工',
      avatar: '/d/u2.jpg',
    },
    rating: 5,
    date: '2024-03-10',
    content: 'DKE51型号联轴器已经多次采购，质量稳定，尺寸标准，安装非常方便。双膜片结构在补偿偏差方面表现很好，适合精密传动系统使用，性价比很高。',
    images: [
      '/d/2.webp',
    ],
    variant: 'DKE51/DKE56阶梯式膜片式联轴器（双膜片）',
    helpfulCount: 54,
  },
  {
    id: '3',
    user: {
      name: '王**师',
      avatar: '/d/u3.jpg',
    },
    rating: 4,
    date: '2024-03-08',
    content: '经济型膜片式联轴器整体表现不错，满足一般工况完全没问题。单膜片版本结构简单，维护方便，不过在高负载场景下建议选双膜片型号更稳。',
    variant: '膜片式联轴器 螺钉夹紧型 经济型（单膜片）',
    helpfulCount: 33,
  },
  {
    id: '4',
    user: {
      name: '赵**工',
      avatar: '/d/u4.jpg',
    },
    rating: 5,
    date: '2024-03-05',
    content: '免键式膜片联轴器安装效率非常高，不需要额外键槽加工，大大节省了装配时间。运行同心度好，适合自动化产线，推荐给有装配效率要求的项目。',
    images: [
      '/d/3.webp',
    ],
    variant: '膜片免键式联轴器（双膜片）',
    helpfulCount: 71,
  },
  {
    id: '5',
    user: {
      name: '孙**工',
      avatar: '/d/u5.jpg',
    },
    rating: 5,
    date: '2024-03-02',
    content: '法兰单锥型胀紧套配合紧密，传递扭矩稳定，没有打滑现象。安装拆卸都比较方便，对轴无损伤，适合需要频繁维护的设备，整体质量可靠。',
    images: [
      '/d/4.webp',
    ],
    variant: '法兰单锥型胀紧套',
    helpfulCount: 112,
  }
];

export default function ProductevaluateList() {
  return (
    <div className="h-[800px] overflow-y-auto py-6 px-4 ">
      <div className=" space-y-4">
        <h2 className="text-xl font-bold text-gray-900 mb-6">评价晒单 ({evaluateList.length})</h2>
        
        {evaluateList.map((evaluation) => (
          <div key={evaluation.id} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
            {/* Header: User info & Date */}
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <img 
                  src={evaluation.user.avatar} 
                  alt={evaluation.user.name} 
                  className="w-10 h-10 rounded-full object-cover border border-gray-200"
                  referrerPolicy="no-referrer"
                />
                <div>
                  <div className="font-medium text-gray-900 text-sm">{evaluation.user.name}</div>
                  <div className="flex items-center mt-1">
                    {[...Array(5)].map((_, i) => (
                      <Star 
                        key={i} 
                        className={`w-3.5 h-3.5 ${i < evaluation.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-200'}`} 
                      />
                    ))}
                  </div>
                </div>
              </div>
              <div className="text-sm text-gray-500">{evaluation.date}</div>
            </div>

            {/* Content */}
            <p className="text-gray-800 text-base leading-relaxed mb-4">
              {evaluation.content}
            </p>

            {/* Images */}
            {evaluation.images && evaluation.images.length > 0 && (
              <div className="flex flex-wrap gap-2 mb-4">
                {evaluation.images.map((img, idx) => (
                  <div key={idx} className="w-24 h-24 rounded-lg overflow-hidden border border-gray-100 cursor-pointer hover:opacity-90 transition-opacity">
                    <img 
                      src={img} 
                      alt={`Review image ${idx + 1}`} 
                      className="w-full h-full object-cover"
                      referrerPolicy="no-referrer"
                    />
                  </div>
                ))}
              </div>
            )}

            {/* Footer: Variant & Actions */}
            <div className="flex items-center justify-between text-sm text-gray-500 mt-4 pt-4 border-t border-gray-50">
              <div className="truncate pr-4">
                {evaluation.variant && <span>{evaluation.variant}</span>}
              </div>
              <div className="flex items-center space-x-4 shrink-0">
                <button className="flex items-center space-x-1.5 hover:text-blue-600 transition-colors">
                  <ThumbsUp className="w-4 h-4" />
                  <span>{evaluation.helpfulCount}</span>
                </button>
                <button className="hover:text-gray-900 transition-colors">
                  <MoreHorizontal className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
